// @flow
import axios from 'lib/defaultClient';

export const like = (quoteId: string) => axios.post(`/quotes/${quoteId}/like`);

export const unlike = (quoteId: string) => axios.delete(`/quotes/${quoteId}/like`);

export const getLikesCount = (quoteId: string) => axios.get(`/quotes/${quoteId}/like`);



// WEBPACK FOOTER //
// ./src/lib/api/quotes/like.js